import React, { useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { postCustomerOrderChargesAdd } from "../../services/OrderEdit/orderInfoEdit";
import { Dropdown } from "primereact/dropdown";
import { getLocalChargesAndDiscount, getStoreLocalData } from "../../utils/localStorage";
import { getChargesAndDiscount } from "../../services/Cart/getChargesAndDiscount";
import { getCustomerSingleOrderInfo } from "../../services/OrdersAPI/Orders";

const BookingInfoChargesAdd = ({
  bookingInfoChargesAddModalVisible,
  setBookingInfoChargesAddModalVisible,
  sendDataToBookingInfoChargesAdd,
  storeCustomerId,
  bookingOrderId,
  storeId,
  chargeData,
  userRole,
}) => {
  const [customChargeValue, setCustomChargeValue] = useState("");
  const [customChargeValueTotal, setCustomChargeValueTotal] = useState("");
  const [customChargeCountValue, setCustomChargeCountValue] = useState("1");

  const { storeLocalData } = getStoreLocalData();

  const [charges, setCharges] = useState([]);
  const [addChargesValue, setAddChargesValue] = useState("");
  const [selectedChargesValue, setSelectedChargesValue] = useState({});
  const [selectedChargeAmount, setSelectedChargeAmount] = useState("");

   const [customerOrdersData, setCustomerOrdersData] = useState([]);
  
    const fetchCustomerSingleOrder = () => {
      // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
      getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            setCustomerOrdersData(Res);
          }
        })
        .catch((err) => {
          console.error("getCustomerSingleOrder Error:", err);
        });
    };

  const fetchStoreChargesAndDiscount = async () => {
      try {
        const response = await getChargesAndDiscount(storeId);
        if (!response.data.error) {
          const Res = response.data;
          const [chargeArray] = Res.reduce(
            ([charges], item) => {
              if (
                item.chargeDiscountMode === "ALL" ||
                item.chargeDiscountMode === "BOOKING"
              ) {
                if (
                  item.chargeDiscountType === "CHARGE" &&
                  item.chargeDiscountTypeIn === "AMOUNT"
                )
                  charges.push(item);
              }
              return [charges];
            },
            [[], []]
          );
          setCharges(chargeArray);
        }
      } catch (err) {
        console.error("Error:", err);
      }
    };

  const fetchLocalChargesAndDiscount = async () => {
    const { chargesAndDiscount } = getLocalChargesAndDiscount();
    if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
      const [chargeArray] = chargesAndDiscount.reduce(
        ([charges], item) => {
          if (
            item.chargeDiscountMode === "ALL" ||
            item.chargeDiscountMode === "BOOKING"
          ) {
            if (
              item.chargeDiscountType === "CHARGE"
              // && item.chargeDiscountTypeIn === "AMOUNT"
            )
              charges.push(item);
          }
          return [charges];
        },
        [[], []]
      );

      setCharges(chargeArray);
    } else {
      setCharges([]);
    }
  };

  useEffect(() => {
    // Check if selectedPackageItemValue is available
    // const roundOffValue = chargeAmountPreviousValue?.amount?.toFixed(0);
    // const countValue = chargeAmountPreviousValue?.count?.toFixed(0);
    // setCustomChargeValue(roundOffValue?.toString());
    // setCustomChargeCountValue(countValue?.toString());

    fetchCustomerSingleOrder();
     if (userRole === "BY_STORE") {
       fetchLocalChargesAndDiscount();
     } else {
       fetchStoreChargesAndDiscount();
     }
  }, []);

  const addChargesData = charges.map((item, index) => ({
    id: index + 1,
    chargeDiscountId: item.id,
    name: item.name,
    amount: item.chargeDiscount,
    chargeDiscountType: item.chargeDiscountType,
    chargeDiscountTypeIn: item.chargeDiscountTypeIn,
    description: item.description,
    orderChargeDiscountMode: item.chargeDiscountMode,
  }));

  const dropdownItems = addChargesData.filter(
    (charge) =>
      !chargeData.some(
        (selectedCharge) =>
          selectedCharge.chargeDiscountId === charge.chargeDiscountId
      )
  );
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [errorText, setErrorText] = useState("");

  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);
  const [showUpdateButton, setShowUpdateButton] = useState(false);

  const getChargeDiscountSymbol = (type) => {
    switch (type) {
      case "AMOUNT":
        return storeLocalData?.currencySymbol; // You can use any symbol you prefer for Amount
      case "PERCENTAGE":
        return "%"; // Use '%' symbol for PERCENTAGE
      default:
        return "";
    }
  };

  const handleAddChargesChange = (charge) => {

    let newChargeAmount;
    if (charge.chargeDiscountTypeIn === "PERCENTAGE") {
      newChargeAmount = Math.round(
        (customerOrdersData.grandTotal * charge.amount) / 100
      );
    } else {
      newChargeAmount = Math.round(charge.amount);
    }

    setAddChargesValue(charge);
    setSelectedChargeAmount(charge.amount);
    setCustomChargeValue(newChargeAmount);
    setCustomChargeValueTotal(newChargeAmount);
    setCustomChargeCountValue("1");
    setSelectedChargesValue(charge);
    setErrorText("");
    setIsSubmitButtonPressed(false);
  };

  const handleChargeAmountChange = (text) => {
    if (!text) {
      setSelectedChargeAmount("");
      setErrorText("Total cannot be empty or zero");
      setIsSubmitButtonPressed(true);
    }
    // else if (parseInt(text) > parseInt(selectedChargesValue.amount)) {
    //   setErrorText(
    //     'Entered Value Can Not Be Greater Then ' +
    //       selectedChargesValue.amount?.toFixed(0),
    //   );
    //   setSelectedChargeAmount(text);
    //   setIsSubmitButtonPressed(true);
    // }
    else {
      setSelectedChargeAmount(text);
      const newChargeValue =
        parseInt(text) * parseInt(customChargeCountValue).toFixed(0);
      // customChargeValue,
      setCustomChargeValue(text);
      setCustomChargeValueTotal(newChargeValue);
      setErrorText("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handleChargeCountChange = (text) => {
    if (!text) {
      setCustomChargeCountValue("");
      setErrorText("Charge Count cannot be empty or zero");
      setIsSubmitButtonPressed(true);
    } else if (parseInt(text) <= parseInt(0)) {
      setErrorText("Count Can't Be Less Then Or Equal to Zero");
      setCustomChargeCountValue(text);
      setIsSubmitButtonPressed(true);
    } else {
      setCustomChargeCountValue(text);
      const newChargeValue = parseInt(text) * parseInt(customChargeValue);
      // parseInt(selectedChargeAmount).toFixed(0);
      // customChargeValue,
      setCustomChargeValueTotal(newChargeValue);
      setErrorText("");
      setIsSubmitButtonPressed(false);
    }
  };

  const handleConfirmation = () => {
    if (!errorText) {
      setIsSubmitButtonPressed(true);
      const data = {
        ...selectedChargesValue,
        amount: parseInt(customChargeValueTotal),
        count: parseInt(customChargeCountValue).toFixed(0),
        chargeDiscountAmount: parseInt(selectedChargesValue.amount),
      };

      postCustomerOrderChargesAdd(
        storeCustomerId,
        storeId,
        bookingOrderId,
        data
      )
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const message = Res.message;
            const status = Res.status;
            sendDataToBookingInfoChargesAdd({
              success: status,
            });
            if (status === true) {
              setModalVisible(true);
              setModalStatus("success");
              setModalText(message);
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText(message);
            }
            setIsSubmitButtonPressed(false);
            setBookingInfoChargesAddModalVisible(false);
            setCustomChargeCountValue("1");
            setAddChargesValue("");
            setSelectedChargeAmount("");
            setCustomChargeValue("");
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
    setShowUpdateButton(true);
  };

  const handleModalClose = () => {
    setIsSubmitButtonPressed(false);
    setBookingInfoChargesAddModalVisible(false);
    setErrorText("");
    setCustomChargeCountValue("1");
    setAddChargesValue("");
    setSelectedChargeAmount("");
    setCustomChargeValue("");
    setShowUpdateButton(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={bookingInfoChargesAddModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!bookingInfoChargesAddModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div>
              <div
                className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
                style={{
                  backgroundImage:
                    "radial-gradient(circle at left top, #2B70D7, #1752AA)",
                }}
              >
                <div></div>

                <p className=" text-4xl text-primary-50 font-semibold">
                  Add Charges
                </p>
                <Button
                  label="x"
                  onClick={(e) => hide(e)}
                  text
                  className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
                ></Button>
              </div>

              <div className="flex-1 mx-4 mb-1 mt-3">
                <div
                  className="border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                >
                  <Dropdown
                    value={addChargesValue}
                    onChange={(e) => handleAddChargesChange(e.value)}
                    options={dropdownItems}
                    optionLabel="name"
                    placeholder="Add Charge"
                    className="w-full  bg-white-alpha-20  text-2xl text-primary-50"
                  />
                </div>
              </div>
              {addChargesValue.chargeDiscountTypeIn === "AMOUNT" && (
                <div className="mx-4 mt-3">
                  <div className="mt-1 mx-1">
                    <div className="flex flex-row justify-content-between">
                      <div>
                        <p className=" text-xl font-semibold">Charge</p>
                      </div>
                      <div>
                        <p className=" text-xl font-semibold">Count</p>
                      </div>
                      <div>
                        <p className=" text-xl font-semibold">Total</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-1 mb-2 mx-1">
                    <div className="flex flex-row justify-content-between gap-4">
                      <div className="border-round-xl shadow-4">
                        <InputText
                          placeholder="Charge"
                          value={selectedChargeAmount}
                          maxLength={50}
                          onChange={(e) =>
                            handleChargeAmountChange(e.target.value)
                          }
                          className="w-full border-none px-3 text-md "
                        ></InputText>
                      </div>

                      <div className="border-round-xl shadow-4">
                        <InputText
                          placeholder="Count"
                          value={customChargeCountValue}
                          maxLength={50}
                          onChange={(e) =>
                            handleChargeCountChange(e.target.value)
                          }
                          className=" w-full border-none px-3 text-md "
                        ></InputText>
                      </div>

                      <div className="flex justify-content-center align-items-center">
                        <p className=" text-xl font-semibold">
                          {storeLocalData?.currencySymbol}{customChargeValueTotal}
                        </p>
                      </div>
                    </div>
                  </div>

                  {errorText && (
                    <div
                      style={{
                        marginTop: 2,
                        marginBottom: 10,
                        alignSelf: "center",
                      }}
                    >
                      <p style={{ color: "red" }}>{errorText}</p>
                    </div>
                  )}
                </div>
              )}

              {addChargesValue.chargeDiscountTypeIn === "PERCENTAGE" && (
                <div className="mx-4 mt-3">
                <div className="mt-1 mx-1">
                  <div className="flex flex-row justify-content-between">
                    <div>
                      <p className=" text-xl font-semibold">Charge Percentage</p>
                    </div>
                      <div>
                        <p className=" text-xl font-semibold">Order Amount</p>
                      </div>
                      
                    <div>
                      <p className=" text-xl font-semibold">Total</p>
                    </div>
                  </div>
                </div>
                <div className="mt-1 mb-2 mx-1">
                  <div className="flex flex-row justify-content-between gap-4">
                    <div className="border-round-xl shadow-4">
                      <InputText
                        placeholder="Charge"
                        value={selectedChargeAmount}
                        maxLength={50}
                        disabled={true}
                        className="w-full border-none px-3 text-md "
                      ></InputText>
                    </div>

                      <div className="border-round-xl shadow-4">
                        <InputText
                          placeholder="grandTotal"
                          value={customerOrdersData.grandTotal}
                          maxLength={50}
                          disabled={true}
                          className="w-full border-none px-3 text-md "
                        ></InputText>
                      </div>

                      

                    <div className="flex justify-content-center align-items-center">
                      <p className=" text-xl font-semibold">
                          {storeLocalData?.currencySymbol}{customChargeValueTotal}
                      </p>
                    </div>
                  </div>
                </div>

                {errorText && (
                  <div
                    style={{
                      marginTop: 2,
                      marginBottom: 10,
                      alignSelf: "center",
                    }}
                  >
                    <p style={{ color: "red" }}>{errorText}</p>
                  </div>
                )}
              </div>
              )}
            </div>

            <Button
              disabled={
                selectedChargeAmount === "" ? true : isSubmitButtonPressed
              }
              onClick={handleConfirmation}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                ADD
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <SuccessModal
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        status={modalStatus}
        text={modalText}
      />
    </div>
  );
};

export default BookingInfoChargesAdd;
